var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
export var reset = {
    alignItems: 'flex-start',
    borderCollapse: 'separate',
    borderSpacing: 0,
    color: 'black',
    display: 'block',
    fontFamily: '"Open Sans", Arial, sans-serif',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    justifyContent: 'flex-start',
    letterSpacing: 'normal',
    lineHeight: 'normal',
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    textAlign: 'left',
    textIndent: 0,
    textTransform: 'none',
    textShadow: 'none',
    verticalAlign: 'baseline',
    wordSpacing: 'normal',
};
var icons = {
    up: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Ebold/chevron-up-bold%3C/title%3E%3Cpath fill='XXXXX' d='M63.998 30.18c.513 0 1.028.196 1.424.592l60.802 60.803c.784.783.786 2.05.009 2.828l-8.494 8.494c-.779.779-2.04.78-2.828-.009L64.003 51.981l-50.907 50.907a2.001 2.001 0 0 1-2.829.009l-8.493-8.494a1.995 1.995 0 0 1 .008-2.828l60.803-60.803c.393-.393.908-.59 1.422-.59z'  fill-rule='evenodd'/%3E%3C/svg%3E",
    down: "data:image/svg+xml,%3Csvg width='128' height='128' viewBox='0 0 128 128' xmlns='http://www.w3.org/2000/svg'%3E%3Ctitle%3Ebold/chevron-down-bold%3C/title%3E%3Cpath fill='XXXXX' d='M63.998 97.82c.513 0 1.028-.196 1.424-.592l60.802-60.802c.784-.784.786-2.051.009-2.829l-8.494-8.493a1.995 1.995 0 0 0-2.828.008L64.003 76.019 13.096 25.112a2.001 2.001 0 0 0-2.829-.008l-8.493 8.493c-.78.779-.78 2.04.008 2.829l60.803 60.802c.393.393.908.59 1.422.59z'  fill-rule='evenodd'/%3E%3C/svg%3E",
};
export var list = __assign(__assign({}, reset), { borderBottom: '1px solid #cccccc', width: '100%' });
export var groupRow = {
    alignItems: 'center',
    background: '#f5f5f5',
    borderTop: '1px solid #cccccc',
    color: '#222222',
    display: 'flex',
    fontWeight: '600',
    lineHeight: "".concat(16, "px"),
    padding: 8,
};
export var groupRowCollapsible = __assign(__assign({}, groupRow), { cursor: 'pointer' });
export var groupTitleContainer = {
    flexGrow: 1,
};
export var groupRowCollapsedIcon = {
    ':after': __assign(__assign({}, getIcon(icons.down, 16, '#666666')), { content: '""', marginBottom: -2, marginRight: 4 }),
};
export var groupRowExpandedIcon = {
    ':after': __assign(__assign({}, getIcon(icons.up, 16, '#666666')), { content: '""', marginBottom: -2, marginRight: 4 }),
};
export var actions = {
    alignItems: 'center',
    display: 'flex',
    paddingRight: 8,
};
export var actionsSelected = __assign(__assign({}, actions), { backgroundColor: '#1588af', color: "".concat('#ffffff', " !important"), '*': {
        filter: 'brightness(100)',
    } });
export var actionsSelectedDisabled = __assign(__assign({}, actionsSelected), { backgroundColor: "".concat('#cccccc', " !important") });
export var itemContainer = {
    background: '#ffffff',
    borderTop: '1px solid #cccccc',
    color: '#222222',
    display: 'flex',
    lineHeight: "".concat(16, "px"),
};
export var itemContainerClickable = {
    ':hover': {
        background: '#eaeaea',
        cursor: 'pointer',
    },
};
export var itemContainerDisabled = __assign(__assign({}, itemContainer), { color: "".concat('#cccccc', " !important"), cursor: 'not-allowed', ':hover': {} });
export var itemContainerSelected = __assign(__assign({}, itemContainer), { ':hover': __assign(__assign({}, itemContainer[':hover']), { background: itemContainer.background, cursor: 'pointer' }) });
export var item = {
    alignItems: 'center',
    flexGrow: 1,
    padding: 8,
};
export var itemSelected = __assign(__assign({}, item), { backgroundColor: '#1588af', color: "".concat('#ffffff', " !important") });
export var itemSelectedDisabled = __assign(__assign({}, itemSelected), { background: "".concat('#cccccc', " !important") });
export var inputContainer = {
    alignItems: 'center',
    borderLeft: '2px solid transparent',
    borderRight: '1px solid #cccccc',
    display: 'flex',
    padding: "0 ".concat(8, "px"),
};
export var inputContainerSelected = __assign(__assign({}, inputContainer), { border: "2px solid ".concat('#1588af'), borderRightWidth: 1 });
export var inputContainerSelectedDisabled = __assign(__assign({}, inputContainerSelected), { border: '2px solid #cccccc', borderRightWidth: 1 });
export var inputGroupContainer = {
    alignItems: 'center',
    borderLeft: '2px solid transparent',
    display: 'flex',
    padding: "0 ".concat(8, "px 0 0"),
};
export var inputGroupContainerSelected = __assign({}, inputGroupContainer);
export var inputGroupContainerSelectedDisabled = __assign(__assign({}, inputGroupContainerSelected), { border: '2px solid #cccccc' });
export var input = {
    ':hover': {
        cursor: 'pointer',
    },
};
export var inputDisabled = {
    cursor: 'not-allowed',
};
var ribbon = {
    content: '""',
    display: 'block',
    width: 8,
};
export var positive = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#3dc270' }),
};
export var info = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#41a8d2' }),
};
export var warning = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#ff8800' }),
};
export var negative = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#c8102e' }),
};
export var pending = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#ffc400' }),
};
export var color1 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#41a8d2' }),
};
export var color2 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#ffd70b' }),
};
export var color3 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#3dc270' }),
};
export var color4 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#d43046' }),
};
export var color5 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#5e4982' }),
};
export var color6 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#ff8800' }),
};
export var color7 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#f8b100' }),
};
export var color8 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#11779c' }),
};
export var color9 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#53d168' }),
};
export var color10 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#d1eb58' }),
};
export var color11 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#a95998' }),
};
export var color12 = {
    ':before': __assign(__assign({}, ribbon), { backgroundColor: '#f59299' }),
};
